import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  addRequirementData: [],
};

export const AddRequirementDataSlice = createSlice({
  name: "addRequirementData",
  initialState,
  reducers: {
    getAddRequirementDataAction: (state, action) => {
      state.addRequirementData = action.payload;
    },
  },
});

export default AddRequirementDataSlice.reducer;

export const { getAddRequirementDataAction } = AddRequirementDataSlice.actions;
